import React, { useState } from "react";
import TableHeader from "../../components/Common/TableHeader";

export default function SamplePage() {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [units, setUnits] = useState("");
  const [landlord, setLandlord] = useState("");
  const [selectedRange, setSelectedRange] = useState(""); // Used for dropdown-based date ranges
  const [property, setProperty] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleSearch = () => {
    console.log("Searching:", {
      search,
      status,
      type,
      units,
      landlord,
      selectedRange,
      startDate,
      endDate,
      property,
    });
  };

  const handleExport = () => {
    console.log("Exporting CSV...");
  };

  const handleDownload = () => {
    console.log("Downloading Reports...");
  };

  return (
    <div className="space-y-6 p-6">
      {/* Header 1: Filters + Date Picker + Buttons */}
      <TableHeader
        filters={[
          {
            name: "landload",
            value: landlord,
            onChange: setLandlord,
            options: [
              { label: "All", value: "" },
              { label: "Landlord A", value: "landlord-a" },
              { label: "Landlord B", value: "landlord-b" },
            ],
          },
          {
            name: "Property",
            value: property,
            onChange: setProperty,
            options: [
              { label: "All", value: "" },
              { label: "Property 1", value: "property-1" },
              { label: "Property 2", value: "property-2" },
            ],
          },
        ]}
        datePicker={{
          startDate,
          endDate,
          onChange: (field, value) =>
            field === "startDate" ? setStartDate(value) : setEndDate(value),
        }}
        buttons={[
          {
            label: "SEARCH",
            onClick: handleSearch,
            className:
              "bg-[#C084FC] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-4 rounded-[4px] w-[100px] uppercase font-medium",
          },
          {
            label: "DOWNLOAD REPORTS",
            onClick: handleDownload,
            className:
              "bg-[#A855F7] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-4 rounded-[4px] w-[170px] uppercase font-bold",
          },
        ]}
        containerClass="bg-[#F8FAFC] border border-[#E2E8F0] flex flex-wrap justify-between rounded-[10px]"
        filterDropdownClass="w-[180px]"
        datePickerClass="w-[180px]"
        buttonWrapperClass="flex justify-center  w-full mt-3 md:mt-0"
        buttonClass="flex justify-center w-full"
      />

      {/* Header 2: Search + Filters + Date Picker + Buttons */}
      <TableHeader
        searchValue={search}
        onSearchChange={setSearch}
        onSearchSubmit={handleSearch}
        searchPlaceholder="Tenant name / Unit ID"
        filters={[
          {
            name: "landload",
            value: landlord,
            onChange: setLandlord,
            options: [
              { label: "All", value: "" },
              { label: "Landlord A", value: "landlord-a" },
              { label: "Landlord B", value: "landlord-b" },
            ],
          },
          {
            name: "Units",
            value: units,
            onChange: setUnits,
            options: [
              { label: "All", value: "" },
              { label: "Unit 1", value: "unit-1" },
              { label: "Unit 2", value: "unit-2" },
            ],
          },
        ]}
        datePicker={{
          startDate,
          endDate,
          onChange: (field, value) =>
            field === "startDate" ? setStartDate(value) : setEndDate(value),
        }}
        buttons={[
          {
            label: "Search",
            onClick: handleSearch,
            className:
              "bg-[#873FE2B0] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[100px] ",
          },
          {
            label: "Download Reports",
            onClick: handleDownload,
            className:
              "bg-[#873FE2] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] font-bold uppercase w-[154px]",
          },
        ]}
        containerClass="bg-[#f8f8ff] flex-wrap"
        filterDropdownClass="w-full md:w-[180px] lg:w-[247px]"
        datePickerClass="gap-2"
        buttonWrapperClass="justify-center"
        buttonClass="uppercase tracking-wide flex justify-center"
      />
      {/* Header 3: Search Only */}
      <TableHeader
        searchValue={search}
        onSearchChange={setSearch}
        onSearchSubmit={handleSearch}
        searchPlaceholder="Search by name, email"
        buttons={[
          {
            label: "Search",
            onClick: handleSearch,
            className:
              "bg-[#873FE2B0] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[100px] ",
          },
        ]}
        containerClass="bg-[#f8f8ff] grid grid-cols sm:grid-cols-1 md:grid-cols-3 xl:grid-cols-3 "
        searchInputClass="text-gray-700 h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px]"
        buttonWrapperClass="justify-start"
        buttonClass="bg-[#8A65FF] text-white"
      />

      {/* Header 4: Search + Date Range Dropdown */}
      <TableHeader
        searchValue={search}
        onSearchChange={setSearch}
        onSearchSubmit={handleSearch}
        searchPlaceholder="Search by landlord"
        dateRangeFilter={{
          value: selectedRange,
          onChange: setSelectedRange,
          options: [
            { label: "Today", value: "today" },
            { label: "This Week", value: "this_week" },
            { label: "This Month", value: "this_month" },
            { label: "Last Month", value: "last_month" },
          ],
        }}
        buttons={[
          {
            label: "Search",
            onClick: handleSearch,
            className:
              "bg-[#873FE2B0] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[100px] ",
          },
        ]}
        containerClass="bg-[#f8f8ff] grid grid-cols sm:grid-cols-1 md:grid-cols-3 xl:grid-cols-3 "
        searchInputClass="text-gray-600"
        datePickerClass="gap-2"
        buttonWrapperClass="justify-end"
      />

      {/* Header 5: Search + Status Filter + Date Range Dropdown + Export */}
      <TableHeader
        searchValue={search}
        onSearchChange={setSearch}
        onSearchSubmit={handleSearch}
        searchPlaceholder="Search by landlord name or bank reference"
        dateRangeFilter={{
          value: selectedRange,
          onChange: setSelectedRange,
          options: [
            { label: "Today", value: "today" },
            { label: "This Week", value: "this_week" },
            { label: "This Month", value: "this_month" },
            { label: "Last Month", value: "last_month" },
          ],
        }}
        filters={[
          {
            name: "Status",
            value: status,
            onChange: setStatus,
            options: [
              { label: "All", value: "" },
              { label: "Pending", value: "pending" },
              { label: "Approved", value: "approved" },
            ],
          },
        ]}
        buttons={[
          {
            label: "Export CSV",
            onClick: handleExport,
            variant: "secondary",
            className:
              "bg-[#873FE2] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[102px] ",
          },
        ]}
        containerClass="bg-[#f8f8ff] grid grid-cols sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 "
        filterDropdownClass="text-sm w-full md:w-[180px] lg:w-[247px]"
        datePickerClass="gap-2"
        buttonClass="bg-[#6B46C1]"
      />

      {/* Header 6: Search + Type Filter + Date Range Dropdown */}
      <TableHeader
        searchValue={search}
        onSearchChange={setSearch}
        onSearchSubmit={handleSearch}
        searchPlaceholder="Search by tenant name, landlord, or unit ID"
        filters={[
          {
            name: "Type",
            value: type,
            onChange: setType,
            options: [
              { label: "All", value: "" },
              { label: "Rent", value: "rent" },
              { label: "Lease", value: "lease" },
            ],
          },
        ]}
        dateRangeFilter={{
          value: selectedRange,
          onChange: setSelectedRange,
          options: [
            { label: "Today", value: "today" },
            { label: "This Week", value: "this_week" },
            { label: "This Month", value: "this_month" },
            { label: "Last Month", value: "last_month" },
          ],
        }}
        buttons={[
          {
            label: "Search",
            onClick: handleSearch,
            className:
              "bg-[#873FE2B0] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[100px] ",
          },
        ]}
        containerClass="bg-[#f8f8ff] grid grid-cols sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 "
        filterDropdownClass="w-[150px]"
        datePickerClass="gap-2"
        buttonWrapperClass="justify-end"
      />
    </div>
  );
}
